import styled from 'styled-components';

const CheckboxInput = styled.div`
  user-select: none;
  > input {
    position: absolute;
    opacity: 0;

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }
  & + label:before {
    content: '';
    /* margin-right: 10px; */
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border:solid 2px ${({ theme }) => theme.lightGray};
  }

  &:hover + label:before {
    background: ${({ theme }) => theme.lightWhite};
  }
  
  &:focus + label:before {
    /* box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.12); */
  }

  &:checked + label:before {
    background: #78b8f8;
    border:0;
  }
  
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  &:disabled + label:before {
    box-shadow: none;
    background: ${({ theme }) => theme.lightGray};
  }

  &:checked + label:after {
    content: '';
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 
      2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
    transform: rotate(45deg);
  }
  }
`;

export default CheckboxInput;



// WEBPACK FOOTER //
// client/components/Checkbox/CheckboxInput.js